import gql from 'graphql-tag';

export default gql`
mutation adminUpdateTimetableTimeSlot (
    $id: Int!
    $status: TimetableTimeSlotStatusType!
) {
    adminUpdateTimetableTimeSlot (input: {id: $id, status: $status}) {
        id
        status
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminUpdateTimetableTimeSlot.ts